module.exports = __webpack_public_path__ + "img/switch-icon.df3d3cb8.svg";